import { Component, OnInit } from '@angular/core'
import { Router } from '@angular/router'

@Component({
  standalone: false,
  selector: 'vs-contact-us-section',
  templateUrl: './contact-us-section.component.html',
  styleUrls: ['./contact-us-section.component.scss'],
})
export class ContactUsSectionComponent implements OnInit {
  constructor(private router: Router) {}

  ngOnInit(): void {}

  redirectToContactUs() {
    this.router.navigate(['/contactus'])
  }
}
